import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import BasicTable from "@/components/BasicTable";
import { getTimeToString } from "@/utils/toolt";

export default function CaseLog() {
  const { t } = useTranslation();
  const { id } = useParams();
  return (
    <div className="p-4">
      <BasicTable
        columns={[
          {
            title: t("time"),
            dataIndex: "datetime",
            render: (text: any) => <>{getTimeToString(text)}</>,
          },
          { title: t("event"), dataIndex: "event" },
        ]}
        isDefaultToolBar={false}
        isShowCheckbox={false}
        rowKey="event"
        dataKey="data.body.logs"
        className="min-h-[calc(100vh-202px)]"
        requestUrl={`/api/lift/complaint/log?id=${id}`}
      />
    </div>
  );
}
